import {LoadBalanceConfiguration, LoadBalanceForm} from '../../../../fields/loadBalance/types'
import {CreateFormInput} from '../types'

export const buildLoadBalanceForm = (
  input: CreateFormInput<LoadBalanceConfiguration>
): LoadBalanceForm => {
  const schedule = input.order.schedules[0]
  const config = input.configuration.loadBalance
  const rawMaxLoadSize = schedule?.maxLoadSize

  return {
    // Cap the initial maxLoadSize at maxTruckSize so we never start the form with a
    // value that exceeds the physical truck capacity (e.g. order stored 11.5 m³ but
    // the truck constraint says the max load is 8 m³ after correction).
    // When loadBalance is disabled, pass the raw value through unchanged so that
    // dirty tracking still works correctly on round-trip.
    maxLoadSize:
      rawMaxLoadSize !== undefined && config.isEnabled
        ? Math.min(rawMaxLoadSize, config.maxTruckSize)
        : rawMaxLoadSize
  }
}
